import {
    Box,
    Button,
    Typography
} from '@mui/material'
import CustomerSupportBG from '../../../assets/customer-support/customer_support_bg.png'
import { ROOT_PATH} from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppHomeContactUs: React.FC = () => {
    const { t } = useTranslation()

    // 打开contact us
    const openContactUs = () => {
        window.open(ROOT_PATH + '/contact-us')
    }
    
    // ======================= VIEWS
    return (
        <Box sx={{
            paddingLeft: '12px',
            paddingRight: '12px',
        }}>
            <Box
                sx={{
                    width: '100%',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                    paddingTop: '40px',
                    paddingBottom: '40px',
                    borderRadius: '5px',
                    display: 'flex',
                    alignContent: 'start',
                    alignItems: 'start',
                    justifyContent: 'start',
                    flexDirection: 'column',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundImage: `url(${CustomerSupportBG})`,
                }}
            >
                <Box>
                    <Typography fontWeight={500} fontSize={'14px'} color={'#000000'}>
                        {t('t77')}
                    </Typography>

                    <Typography paddingTop={'15px'} fontWeight={600} fontSize={'20px'} color={'#000000'}>
                        {t('t78')}  
                        {t('t79')}
                    </Typography>
                </Box>
                <Box>
                
                <Button
                    onClick={openContactUs}
                    variant='contained'
                    sx={{
                        color: '#141F39',
                        mt: 6,
                        bgcolor: '#FFC107',
                        '&:hover': {
                            bgcolor: '#FFC107',
                        },
                        height: '60px',
                        width: '200px',
                        borderRadius: '50px',
                        textTransform: 'none',
                    }}
                >
                    <Typography textAlign={'center'} fontSize={15} fontWeight={500} color={'#141F39'}>
                        {t('t80')}
                    </Typography>
                </Button>
                 
                </Box>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppHomeContactUs
